import { Loader } from "@mantine/core";
// import PreviewHeader from "components/header/PreviewHeader";
import AdminStatementAndInvoicesPreview from "pages/admin/reports/AdminStatementAndInvoicesPreview";
import { useSearchParams } from "react-router-dom";

const PrintStatementAndInvoices: React.FC = () => {
  const [params] = useSearchParams();
  const id = params.get("id");
  const includeInv = params.get("i");
  if (!id) return <Loader />;
  return (
    <div className="inner-container">
      {/* <PreviewHeader /> */}
      <AdminStatementAndInvoicesPreview
        id={Number(id)}
        includeInvoices={includeInv === "1"}
      />
    </div>
  );
};

export default PrintStatementAndInvoices;
